import { useState, useContext } from "react";
import { Slider } from "@material-tailwind/react";
import GlobalContext, { UPDATE_WITHDRAWAL_TYPE } from '../GlobalProvider';


function StepFive({ currentStep, setCurrentStep, formvalues, setFormvalues }) {
  const { state, dispatch } = useContext(GlobalContext);
  const { withdrawal_type } = state;
  
  const [selectedButton, setSelectedButton] = useState(withdrawal_type === false ? 0 : 1);

  // const handleClick = (button) => {
  //   setSelectedButton(button);
  //   // setFormvalues({...formvalues, withdrawal_type: button})
  // };

  // const handleClick = (button) => {
  //   setSelectedButton(button);
  //   dispatch({
  //     type: UPDATE_WITHDRAWAL_TYPE, // Using the new action type
  //     payload: { withdrawal_type: button === 0 ? false : true },
  //   });
  // };

  const handleClick = (button) => {
    // setSelectedButton(button);
    // Update withdrawal_type in context based on button value
    dispatch({
      type: UPDATE_WITHDRAWAL_TYPE,
      payload: button === 0 ? false : true,
    });
  };
  


  // return (
  //   <div>
  //     <div className="text-center font-medium font-serif mb-5">
  //       <p>Select a type of goal?</p>
  //     </div>
  //     <div className="flex justify-center">
  //       <button
  //         className={`${
  //           selectedButton === 0
  //             ? "bg-red-900 hover:text-gray-500"
  //             : "bg-red-950 text-gray-100"
  //         } font-bold py-2 px-4 rounded-l`}
  //         onClick={() => {
  //           handleClick(0);
  //           setSelectedButton(1); // Change selectedButton to the other button
  //         }}
  //       >
  //         Lump Sum
  //       </button>
  //       <button
  //         className={`${
  //           selectedButton === 1
  //             ? "bg-red-900 hover:text-gray-500"
  //             : "bg-red-950 text-gray-100"
  //         } font-bold py-2 px-4 rounded-r`}
  //         onClick={() => {
  //           handleClick(1);
  //           setSelectedButton(0); // Change selectedButton to the other button
  //         }}
  //       >
  //         Program Withdrawal
  //       </button>
  //     </div>
  //       <div className="text-center font-medium font-serif mb-5">
  //         <p>What is your desired lump sum at retirement?</p>
  //       </div>
  //       <div className="flex flex-row justify-between items-center">
  //           <div className="w-1/12 p-0 m-0">
  //               <p>₦0</p>
  //           </div>
  //           <div className="w-11/12 p-0 m-0">
  //               <Slider
  //                   className='flex mt-4 mb-2'
  //                   color="red"
  //                   size="sm"
  //                   min={0}
  //                   max={2000000}
  //                   step={1}
  //                   defaultValue={0}
  //               />
  //           </div>
  //           <div className="w-1/12 p-0 m-0">
  //               <p>N100m</p>
  //           </div>
  //       </div>
//          <div className="text-center ms-4 mt-4 mb-4">
//             <input type="text" 
//             placeholder={formatSalary(formValues.salary)} 
//             defaultValue={formValues.salary}
//             className="styled-input text-center text-red-900"
//             onChange={handleSalaryTextInputChange}
//             />
//         </div> 
//     </div>
// );

  return (
    <div>
      <div className="text-center font-display font-medium mb-5">
        <p>Select a type of goal?</p>
      </div>
      <div className="flex justify-center">
        <button
          className={`${
            selectedButton === 0
              ? "bg-red-900 hover:text-gray-500"
              : "bg-red-950 text-gray-100"
          } font-bold py-2 px-4 rounded-l`}
          onClick={() => {
            handleClick(0);
            setSelectedButton(1); // Change selectedButton to the other button
          }}
        >
          Lump Sum
        </button>
        <button
          className={`${
            selectedButton === 1
              ? "bg-red-900 hover:text-gray-500"
              : "bg-red-950 text-gray-100"
          } font-bold py-2 px-4 rounded-r`}
          onClick={() => {
            handleClick(1);
            setSelectedButton(0); // Change selectedButton to the other button
          }}
        >
          Program Withdrawal
        </button>
      </div>
        <div className="font-display text-center font-medium mt-5 mb-3">
            <p>What is your desired lump sum at retirement?</p>
        </div>
        <div className="flex flex-row justify-between items-center">
            <div className="w-1/12">
                <p>₦0</p>
            </div>
            <div className="w-11/12">
                <Slider className='flex mt-4 mb-2' color="red" size="sm" defaultValue={0}  min={0}  max={2000000}/>
            </div>
            <div className="w-1/12">
                <p>₦100m</p>
            </div>
        </div>
    </div>
  );
}

export default StepFive;
